import { useState } from "react";
import * as React from "react";
import { Delete as DeleteIcon, Share as ShareIcon } from "@mui/icons-material";
import { ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";

import Share from "fond/share/Share";
import { Folder } from "fond/types";
import { Actions, permissionCheck } from "fond/utils/permissions";
import { replaceAllSpecialCharacters } from "fond/utils/strings";

import DeleteCityReportModal from "../CityReport/DeleteCityReportModal";

import StarMenuItem from "./StarMenuItem";
import { CommonItemMenuProps } from "./types";

interface CityReportRowMenuProps extends CommonItemMenuProps {
  /**
   * The city report folder the menu actions relate to
   */
  cityReportFolder: Folder;
  open?: boolean;
}

type cityReportModal = "share" | "delete";

const CityReportRowMenu: React.FC<CityReportRowMenuProps> = ({
  cityReportFolder,
  onMenuClose,
  anchorEl,
  open = true,
  source,
}: CityReportRowMenuProps) => {
  const [showModal, setShowModal] = useState<cityReportModal>();

  if (!cityReportFolder) return null;

  /**
   * Generic Callback function that updates any of the modal open states and closes the menu
   */
  const openModal = (modalType: cityReportModal) => (event: React.MouseEvent<EventTarget>) => {
    onMenuClose(event);
    setShowModal(modalType);
  };

  const closeModal = () => {
    setShowModal(undefined);
  };

  return (
    <Menu
      data-testid={`project-list-item-menu-${replaceAllSpecialCharacters(cityReportFolder.Name, "")}`}
      anchorEl={anchorEl}
      keepMounted
      open={!!anchorEl && open}
      onClose={onMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      {/**
       * TODO - Future ticket
       * Edit
       */}

      <MenuItem
        aria-label="Share Market Lens report"
        onClick={openModal("share")}
        data-testid="share-folder-button-report"
        disabled={!permissionCheck(cityReportFolder.Permission.Level, Actions.FOLDER_SHARE_VIEW)}
      >
        <ListItemIcon>
          <ShareIcon />
        </ListItemIcon>
        <Typography variant="inherit">Share</Typography>
      </MenuItem>

      <MenuItem
        aria-label="Delete Market Lens report"
        onClick={openModal("delete")}
        data-testid="delete-folder-button-report"
        disabled={!permissionCheck(cityReportFolder.Permission.Level, Actions.FOLDER_DELETE)}
      >
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        <Typography variant="inherit">Delete</Typography>
      </MenuItem>

      <StarMenuItem onMenuClose={onMenuClose} resource={cityReportFolder} source={source} />
      {showModal === "share" && <Share resource={cityReportFolder} onClose={closeModal} />}
      {showModal === "delete" && <DeleteCityReportModal cityReportFolder={cityReportFolder} onClose={closeModal} />}
    </Menu>
  );
};

export default CityReportRowMenu;
